export default "<input v-model=\"gifURL\"/>\n<img :src=\"gifURL\"/>";